<template>
  <div class="page-user-show">
    <div class="row">
      <div class="col-md-3">
        <sidebar/>
        
        <div style="margin-top:15px;"></div>

        <friendlinks/>
      </div>
      <div class="col-md-9">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '$modules/birthday/profile/sidebar';
import { mapGetters, mapActions } from 'vuex';
import Friendlinks from '$components/friendlinks';

export default {
  name: 'show',
  components: { Sidebar, Friendlinks },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    ...mapActions(['setUser'])
  }
}
</script>

<style lang="scss">
.page-user-show {
  min-height: 100vh;
}
</style>
